import { NotificationType } from '@connect-x-app/shared-domain-models';

import { DEEPLINK_URL } from '../constants/config';
import { replaceJobTitlePlaceholders } from '../strings';

const NAVIGATION_TYPES = new Set<string>([NotificationType.EXTERNAL_MENTION]);

export type PushNotificationData = {
  body?: string;
  channelId?: string;
  channelType?: string;
  chatroomId?: string;
  messageId?: string;
  title?: string;
  type?: string;
};

export type PushNotificationPayload = Omit<PushNotificationData, 'body' | 'title'> &
  Required<Pick<PushNotificationData, 'body' | 'title'>>;

export type FlightRoomDeepLinkParams = {
  channelId?: string;
  channelType?: string;
  messageId?: string;
  roomId?: string;
  type?: string;
};

export const buildFlightRoomDeepLink = ({
  channelId,
  channelType,
  messageId,
  roomId,
  type,
}: FlightRoomDeepLinkParams): string | null => {
  if (!roomId) {
    return null;
  }

  let link = `${DEEPLINK_URL}rooms/${roomId}`;

  if (channelId && channelType === 'custom') {
    link += `/custom/${channelId}`;
  }

  const params = new URLSearchParams();
  if (messageId) {
    params.append('externalMessageId', messageId);
  }
  if (type && NAVIGATION_TYPES.has(type)) {
    params.append('type', type);
  }
  if (params.toString().length > 0) {
    link += `?${params.toString()}`;
  }

  return link;
};

export const buildFlightRoomPushUrl = (
  roomId?: string,
  channelId?: string,
  externalMessageId?: string,
  channelType?: string,
  type?: string,
) => {
  if (!roomId) {
    return '/dashboard/flightrooms';
  }

  let url = `/dashboard/flightrooms/${roomId}`;

  if (channelId) {
    const channelSegment = channelType === 'custom' ? `/channel/${channelId}` : `/${channelId}`;
    url = url.concat(channelSegment);
  }

  const params = new URLSearchParams();
  if (externalMessageId) {
    params.append('externalMessageId', externalMessageId);
  }
  if (type && NAVIGATION_TYPES.has(type)) {
    params.append('type', type);
  }
  if (params.toString().length > 0) {
    url = url.concat(`?${params.toString()}`);
  }

  return url;
};

export const getPushNotificationPayload = (data?: PushNotificationData): PushNotificationPayload | null => {
  const { body: rawBody, channelId, channelType, chatroomId, messageId, title, type } = data ?? {};

  if (!title || !rawBody) {
    return null;
  }

  const body = replaceJobTitlePlaceholders(rawBody);

  return {
    body,
    channelId,
    channelType,
    chatroomId,
    messageId,
    title,
    type,
  };
};
